const PROMISES = [
  "A written plan and clear quote before any code is written",
  "Weekly updates in plain language, never status-color emoji",
  "Your old system keeps running until the new one is proven",
  "Full source, docs, and runbooks — yours forever",
  "An honest \"we don't think we should do this\" if it isn't right",
];

export function Local() {
  return (
    <section className="section local" id="local">
      <div className="container">
        <div className="local-inner">
          <div className="reveal">
            <span className="eyebrow on-dark">Based in the 828</span>
            <h2>
              From the porch
              <br />
              to <em>production.</em>
            </h2>
            <p>
              We live and work in the Blue Ridge — Asheville, Hendersonville,
              Brevard, Boone. We'll come to you for a day, or work over a shared
              screen. The mountains aren't a metaphor; they're the view out the
              window.
            </p>
            <div className="local-stats">
              <div className="local-stat">
                <div className="v">18+ yrs</div>
                <div className="l">
                  Shipping production software, databases, and automations
                </div>
              </div>
              <div className="local-stat">
                <div className="v">100%</div>
                <div className="l">
                  Human at the wheel. AI assists; it doesn't decide
                </div>
              </div>
            </div>
          </div>

          <div className="ridge-card reveal">
            <h4>What you get on every project</h4>
            <ul>
              {PROMISES.map((p) => (
                <li key={p}>
                  <CheckIcon />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

function CheckIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}
